import React from "react";
import blogData from "../blogList.json";
import "../../public/assets/scss/blogList/_blog.scss";
import {GAEvent} from "../utils/ga";

export default function BlogList() {
  // const data = blogData.results;
  const replaceTag = {
    115785382495: 'Aluguel de equipamentos',
    119367178545: 'Tecnologia',
    124628217149: 'Novidades',
    115811837069: 'Home Office',
    149988153223: 'Recursos Humanos',
  }

  // function lastThirty(data) {
  //   const limitDate = new Date()
  //   limitDate.setDate(limitDate.getDate() - 30)

  //   return new Date(data) >= limitDate && new Date(data) <= new Date()
  // }

  const currentDate = new Date()

const data = blogData.results
  .filter((a) => a.currentState === 'PUBLISHED')
  .sort(
    (a, b) =>
      Math.abs(currentDate - new Date(a.publishDate)) -
      Math.abs(currentDate - new Date(b.publishDate)),
  )
  .slice(0, 3)

  return (
    <div className="blogContainer">
      {data.map((item, index) => (
        <a onClick={()=>{
          GAEvent({
            category: "Blog",
            action: "Abrir Post",
            label: `${item.url}`
          })
        }} className="blogCard" href={item.url} key={index} target="_blank" rel="noopener noreferrer">
          <img
            className="blogImage"
            loading="lazy"
            src={item.featuredImage}
            alt={item.featuredImageAltText + item.name}
          />
          <div className="blogContent">
            <p className="blogType">
              {item.tagIds.map((item, index) => (
                <span key={index}>{replaceTag[item]}</span>
              ))}
            </p>
            <spam className="blogTitle">{item.name}</spam>
            <span className="blogDate">
              {new Date(item.publishDate)
                .toLocaleDateString('pt-BR', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
                .replace(' de ', ' ')
                .replace(' de ', ', ')}
            </span>
            <p className="blogDescription">
              {item.metaDescription.length > 200 ?
                `${item.metaDescription.substring(0, 200)} ...` : item.metaDescription
              }
            </p>
          </div>
        </a>
      ))}

      <a className="btn-default btn-border btn-opacity" style={{background:"#C1C7D0"}}
        onClick href="https://blog.plugify.com.br/" target="_blanl">
        <div data-to-scrollspy-id="apple" className={"ss-item"}>
          Acesse o Blog Plugify
        </div>
      </a>
    </div>

  );
}